/**
 * Warranty Claims Application
 * Main entry point for the warranty claims form
 */
(function() {
    'use strict';

    /**
     * Application initialization
     */
    class WarrantyClaimsApp {
        constructor(customerId, apiEndpoints, categoriesMapping) {
            this.customerId = customerId;
            this.apiEndpoints = apiEndpoints;
            this.categoriesMapping = categoriesMapping;
            this.validator = new WarrantyClaimsValidator();
            this.fileManager = new WarrantyClaimsFileManager(this.validator);
            this.formController = new WarrantyClaimsFormController(
                this.validator,
                this.fileManager,
                this.apiEndpoints,
                this.customerId,
                this.categoriesMapping
            );
        }

        initialize() {
            // Idempotent guard: a second boot for the same form would bind a duplicate
            // submit listener and fire two requests with one token. Flag is form-scoped.
            const form = document.getElementById('product-registration-form');
            if (!form) return;
            if (form.dataset.warrantyInitialized === 'true') return;
            form.dataset.warrantyInitialized = 'true';

            this.fileManager.initialize();
            this.formController.initialize();
        }
    }

    // Export to global scope for initialization from Liquid template
    window.WarrantyClaimsApp = WarrantyClaimsApp;

})();

